import React, { useMemo, useState, useEffect } from "react";
import { useTable, usePagination, useSortBy, useExpanded, useResizeColumns, useFlexLayout } from "react-table";
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import SortIcon from 'mdi-react/SortIcon';
import SortAscendingIcon from 'mdi-react/SortAscendingIcon';
import SortDescendingIcon from 'mdi-react/SortDescendingIcon';
import ReactTablePagination from '@/shared/components/table/components/ReactTablePagination';
import {reducer, useEffectToDispatch, fetchApiData, initialState} from "@/shared/apiTableHelper"
import { fetchRoles } from "@/shared/apiHelper"
import AssignRoleModal from "./AssignRoleModal"
import FilterForm from "../FilterForm";

import {
    Container,
    Card,
    CardBody,
    Row,
    Col,
  } from "reactstrap";

import { USERS_COLUMNS } from "./columns";

const queryClient = new QueryClient()

const DataTable = ({program, setParentTrigger, toggleParent}) => {
    const [filter, setFilter] = useState({ keyword:'' });
    const [useFilter, setUseFilter] = useState(false);
    const [trigger, setTrigger] = useState(0);
    const [isAssignModalOpen, setAssignModalOpen] = useState(false)
    const [user, setUser] = useState(null)
    const [roles, setRoles] = useState(null) //to be passed to assign model

    useEffect(() => {
        if(program?.id && roles === null)
        {
            fetchRoles(program.organization_id, 1)
            .then(data => {
                setRoles(data);
            })
        }
    })

    const toggleAssignModal = () => {
        setAssignModalOpen(prevState => !prevState)
    }
    const onClickStatus = user => {
        setUser(user);
        toggleAssignModal();
    }

    const RenderActions = ({row}) => {
        return (
            <>
                <span onClick={()=>onClickStatus(row.original)} className="link a" >Manage Role</span>
            </>
        )
    }

    const strShowUserStatus = user => {
        return <span>{user?.status?.status ? user.status.status : '--'}</span>
    }
    
    let user_columns = [
        ...USERS_COLUMNS, 
        ...[
            {
                Header: "Status",
                accessor: "user_status_id",
                width: 120,
                Cell: ({ row }) => strShowUserStatus(row.original),
            },
            {
                Header: "Action",
                accessor: "action",
                width: 150,
                Cell: ({ row }) => <RenderActions row={row} />,
            }
        ],
    ]
    let columns = useMemo( () => user_columns, [])


  const defaultColumn = React.useMemo(
      () => ({
        minWidth: 10,
        //width: 150,
        //maxWidth: 400,
        wordWrap:'normal'
      }),
      []
  )

  const [{ queryPageIndex, queryPageSize, totalCount, queryPageFilter, queryPageSortBy, queryTrigger }, dispatch] = React.useReducer(reducer, initialState);

  const apiUrl = `/organization/${program.organization_id}/program/${program.id}/userToAssign`
      
  const { isLoading, error, data, isSuccess } = useQuery(
      ['users', queryPageIndex, queryPageSize, queryPageFilter, queryPageSortBy, queryTrigger],
      () => fetchApiData(
        {
            url: apiUrl,
            page: queryPageIndex,
            size: queryPageSize,
            filter: queryPageFilter,
            sortby: queryPageSortBy,
            trigger: queryTrigger
        }),
      {
          keepPreviousData: true,
          staleTime: Infinity,
      }
  );

  const totalPageCount = Math.ceil(totalCount / queryPageSize)

  const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
      page,
      pageCount,
      pageOptions,
      gotoPage,
      previousPage,
      canPreviousPage,
      nextPage,
      canNextPage,
      setPageSize,
      state: { pageIndex, pageSize, sortBy }
  } = useTable({
      columns,
      data: data ? data.results : [],
      initialState: {
          pageIndex: queryPageIndex,
          pageSize: queryPageSize,
          sortBy: queryPageSortBy,
      },
      manualPagination: true, // Tell the usePagination
      pageCount: data ? totalPageCount : 0,
      autoResetSortBy: false,
      autoResetExpanded: false,
      autoResetPage: false,
      defaultColumn,
      
  },
  useSortBy,
  useExpanded,
  usePagination,
  useResizeColumns, 
  useFlexLayout,
  );
  // const [statusFilterValue, setStatusFilterValue] = useState("");
  const manualPageSize = []
  
  useEffectToDispatch( dispatch, {pageIndex, pageSize, gotoPage, sortBy, filter, data, useFilter, trigger} );

  if (error) {
      return <p>Error: {JSON.stringify(error)}</p>;
  }

  if (isLoading) {
      return <p>Loading...</p>;
  }

    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
        setUseFilter(true);
    };

  if(isSuccess)
  return (
          <>
              <div className='table react-table'>
                <div className="form form--horizontal">
                    <div className="form__form-group pb-4">
                        <div className="col-md-12 col-lg-12">
                           
                            <FilterForm 
                                onClickFilterCallback={handleFilterChange} 
                                roles={roles}
                                filter={filter}
                            />
                        </div>
                    </div>
                </div>
                {user && roles && <AssignRoleModal setParentTrigger={setParentTrigger} isOpen={isAssignModalOpen} toggle={toggleAssignModal} setTrigger={setTrigger} user={user} program={program} roles={roles} toggleParent={toggleParent} />}

                  <table {...getTableProps()} className="table table--stack-mobile">
                      <thead>
                          {headerGroups.map( (headerGroup) => (
                              <tr {...headerGroup.getHeaderGroupProps()}>
                                  {headerGroup.headers.map( column => (
                                      <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                          {column.render('Header')}
                                          {column.isSorted ? <Sorting column={column} /> : ''}
                                          <div
                                              {...column.getResizerProps()}
                                              className={`resizer ${
                                                  column.isResizing ? 'isResizing' : ''
                                              }`}
                                          />
                                      </th>
                                  ))}
                              </tr>
                          ))}
                      </thead>
                        <tbody className="table table--bordered" {...getTableBodyProps()}>
                          {page.map( row => {
                              prepareRow(row);
                              const subCount = (row.id.match(/\./g) || []).length;
                              return (
                                  <tr {...row.getRowProps()}>
                                      {
                                          row.cells.map( cell => {
                                              // console.log(cell)
                                              const paddingLeft = subCount * 20
                                              return <td
                                                {...cell.getCellProps()}
                                                data-label={typeof cell.column.Header === 'string' ? cell.column.Header : ''}
                                              ><span style={cell.column.Header==='#' ? {paddingLeft: `${paddingLeft}px`} : null}>{cell.render('Cell')}</span></td>
                                          })
                                      }
                                  </tr>
                              )
                          })}
                      </tbody>
                      
                  </table>
              </div>
              {(rows.length > 0) && (
                  <>
                      <ReactTablePagination
                      page={page}
                      gotoPage={gotoPage}
                      previousPage={previousPage}
                      nextPage={nextPage}
                      canPreviousPage={canPreviousPage}
                      canNextPage={canNextPage}
                      pageOptions={pageOptions}
                      pageSize={pageSize}
                      pageIndex={pageIndex}
                      pageCount={pageCount}
                      setPageSize={setPageSize}
                      manualPageSize={manualPageSize}
                      dataLength={totalCount}
                      />
                      {/* <div className="pagination justify-content-end mt-2">
                          <span>
                          Go to page:{' '}
                          <input
                              type="number"
                              value={pageIndex + 1}
                              onChange={(e) => {
                              const page = e.target.value ? Number(e.target.value) - 1 : 0;
                              gotoPage(page);
                              }}
                              style={{ width: '100px' }}
                          />
                          </span>{' '}
                          <select
                          value={pageSize}
                          onChange={(e) => {
                              setPageSize(Number(e.target.value));
                          }}
                          >
                          {[10, 20, 30, 40, 50].map((pageSize) => (
                              <option key={pageSize} value={pageSize}>
                              Show {pageSize}
                              </option>
                          ))}
                          </select>
                      </div> */}
                  </>
              )}
          </>
  )
}

const Sorting = ({ column }) => (
    <span className="react-table__column-header sortable">
        {column.isSortedDesc === undefined ? (
                <SortIcon />
            ) : (<span>
                {column.isSortedDesc
                ? <SortAscendingIcon />
                : <SortDescendingIcon />
                }
            </span>)
        }
    </span>
);

const TableWrapper = ({program, organization, setParentTrigger, toggleParent}) => {
    return (
        <QueryClientProvider client={queryClient}>
          <DataTable program={program} organization={organization} setParentTrigger={setParentTrigger} toggleParent={toggleParent} />
        </QueryClientProvider>
    )
}

const AssignUserIndex = ({organization, program, setTrigger, toggleParent}) => {
    if( !program?.id || !organization?.id )  {
        return 'Loading...'
    }
    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <Card>
                        <CardBody>
                            {program && organization && <TableWrapper program={program} organization={organization} setParentTrigger={setTrigger} toggleParent={toggleParent} />}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}
export default AssignUserIndex;
